(function() {
    'use strict';
    angular
        .module('c3WebApp')
        .factory('SignRole', SignRole);

    SignRole.$inject = ['$resource'];

    function SignRole ($resource) {
        var resourceUrl =  'api/sign-roles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
